export default {
  form: {
    versions: {
      label: 'Versiune',
      placeholder: 'Selectați versiunea',
    },
    font_family: {
      label: 'Font',
    },
    background_color: {
      label: 'Culoare fundal',
    },
    promo_frame_primary_color: {
      label: 'Culoare cadru promo',
    },
    promo_frame_discount_label_color: {
      label: 'Culoare reducere cadru promo',
    },
    vip_members_cta_color: {
      label: 'Culoare CTA membri VIP',
    },
    url_cta_color: {
      label: 'Culoare CTA URL',
    },
    url_color: {
      label: 'Culoare URL',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Selectați URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    qr_code_border_color: {
      label: 'Culoare bordură cod QR',
    },
    qr_code_background_color: {
      label: 'Culoare fundal cod QR',
    },
    footer_background_color: {
      label: 'Culoare fundal subsol',
    },
    logo_zoom: {
      label: 'Dimensiune logo',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea stickerului',
  },
};
